module.exports = __webpack_public_path__ + "img/top.ff0f09cf.png";